// extracted by mini-css-extract-plugin
export default {"actions":"browse-files_actions__5-Dqi"};